module.exports = __webpack_public_path__ + "img/login_bg_new2.a533530b.png";